import Link from "next/link";
import React from "react";
import { buildUrlName } from "../../../../lib/generic";
import { useBlogCardWebContext } from "./BlogCardWebProvider";
import { cn } from "../../../../helpers/cn";

type BlogCardLinkProps = {
  children: React.ReactNode;
  className?: string;
};

export const BlogCardWebLink = ({ children, className }: BlogCardLinkProps) => {
  const { state } = useBlogCardWebContext();

  return (
    <Link
      href={{
        pathname: "/blog/[id]/[name]",
        query: {
          id: state.blog.id,
          name: buildUrlName(state.blog.title),
        },
      }}
      onClick={(e) => e.stopPropagation()}
      className={cn("w-full", className)}
    >
      {children}
    </Link>
  );
};
